import { render, staticRenderFns } from "./SequenceMerge.vue?vue&type=template&id=f3489572&scoped=true&"
import script from "./SequenceMerge.vue?vue&type=script&lang=js&"
export * from "./SequenceMerge.vue?vue&type=script&lang=js&"
import style0 from "./SequenceMerge.vue?vue&type=style&index=0&id=f3489572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3489572",
  null
  
)

export default component.exports